import { render, staticRenderFns } from "./indemnityOption.vue?vue&type=template&id=54a86e7c&scoped=true&"
import script from "./indemnityOption.vue?vue&type=script&lang=js&"
export * from "./indemnityOption.vue?vue&type=script&lang=js&"
import style0 from "./indemnityOption.vue?vue&type=style&index=0&id=54a86e7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a86e7c",
  null
  
)

export default component.exports